/*
CSS Browser Selector v0.4.0 (Nov 02, 2010)
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
License: http://creativecommons.org/licenses/by/2.5/
Contributors: http://rafael.adm.br/css_browser_selector#contributors

v0.5.0 2011-08-24
andrew relkin

modified, now detects:
any version of Firefox
more versions of Windows (Win8, Win7, Vista, XP, Win2k)
more versions of IE under unique conditions
more detailed support for Opera
if "no-js" in HTML class: removes and replaces with "js" (<html class="no-js">)

identifies
	browsers: Firefox; IE; Opera; Safari; Chrome, Konqueror, Iron
	browser versions: (most importantly: ie6, ie7, ie8, ie9)
	rendering engines: Webkit; Mozilla; Gecko
	platforms/OSes: Mac; Win: Win7, Vista, XP, Win2k; FreeBSD; Linux/x11 
	devices: Ipod; Ipad; Iphone; WebTV; Blackberry; Android; J2me; mobile(generic)
	enabled technology: JS

v0.6.3 2014-03-06
@silasrm <silasrm@gmail.com>
    - Added support to IE11 
        @see http://msdn.microsoft.com/en-us/library/ie/hh869301(v=vs.85).aspx
        @see http://msdn.microsoft.com/en-us/library/ie/bg182625(v=vs.85).aspx
*/

showLog = true;
function log(m) {
  if (window.console && showLog) {
    console.log(m);
  }
}

function css_browser_selector(u) {
  var uaInfo = {},
    screens = [320, 480, 640, 768, 1024, 1152, 1280, 1440, 1680, 1920, 2560],
    allScreens = screens.length,
    ua = u.toLowerCase(),
    is = function (t) {
      return RegExp(t, "i").test(ua);
    },
    version = function (p, n) {
      n = n.replace(".", "_");
      var i = n.indexOf("_"),
        ver = "";
      while (i > 0) {
        ver += " " + p + n.substring(0, i);
        i = n.indexOf("_", i + 1);
      }
      ver += " " + p + n;
      return ver;
    },
    g = "gecko",
    w = "webkit",
    c = "chrome",
    f = "firefox",
    s = "safari",
    o = "opera",
    m = "mobile",
    a = "android",
    bb = "blackberry",
    lang = "lang_",
    dv = "device_",
    html = document.documentElement,
    b = [
      // browser
      (!/opera|webtv/i.test(ua) && /msie\s(\d+)/.test(ua)) || /trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.test(ua)
        ? "ie ie" + (/trident\/4\.0/.test(ua) ? "8" : RegExp.$1 == "11.0" ? "11" : RegExp.$1)
        : is("firefox/")
        ? g + " " + f + (/firefox\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? " " + f + RegExp.$2 + " " + f + RegExp.$2 + "_" + RegExp.$4 : "")
        : is("gecko/")
        ? g
        : is("opera")
        ? o +
          (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua)
            ? " " + o + RegExp.$2 + " " + o + RegExp.$2 + "_" + RegExp.$4
            : /opera(\s|\/)(\d+)\.(\d+)/.test(ua)
            ? " " + o + RegExp.$2 + " " + o + RegExp.$2 + "_" + RegExp.$3
            : "")
        : is("konqueror")
        ? "konqueror"
        : is("blackberry")
        ? bb +
          (/Version\/(\d+)(\.(\d+)+)/i.test(ua)
            ? " " + bb + RegExp.$1 + " " + bb + RegExp.$1 + RegExp.$2.replace(".", "_")
            : /Blackberry ?(([0-9]+)([a-z]?))[\/|;]/gi.test(ua)
            ? " " + bb + RegExp.$2 + (RegExp.$3 ? " " + bb + RegExp.$2 + RegExp.$3 : "")
            : "")
        : // blackberry

        is("android")
        ? a +
          (/Version\/(\d+)(\.(\d+))+/i.test(ua) ? " " + a + RegExp.$1 + " " + a + RegExp.$1 + RegExp.$2.replace(".", "_") : "") +
          (/Android (.+); (.+) Build/i.test(ua) ? " " + dv + RegExp.$2.replace(/ /g, "_").replace(/-/g, "_") : "")
        : //android

        is("chrome")
        ? w + " " + c + (/chrome\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua) ? " " + c + RegExp.$2 + (RegExp.$4 > 0 ? " " + c + RegExp.$2 + "_" + RegExp.$4 : "") : "")
        : is("iron")
        ? w + " iron"
        : is("applewebkit/")
        ? w +
          " " +
          s +
          (/version\/((\d+)(\.(\d+))(\.\d+)*)/.test(ua)
            ? " " + s + RegExp.$2 + " " + s + RegExp.$2 + RegExp.$3.replace(".", "_")
            : / Safari\/(\d+)/i.test(ua)
            ? RegExp.$1 == "419" || RegExp.$1 == "417" || RegExp.$1 == "416" || RegExp.$1 == "412"
              ? " " + s + "2_0"
              : RegExp.$1 == "312"
              ? " " + s + "1_3"
              : RegExp.$1 == "125"
              ? " " + s + "1_2"
              : RegExp.$1 == "85"
              ? " " + s + "1_0"
              : ""
            : "")
        : //applewebkit

        is("mozilla/")
        ? g
        : "",

      // mobile
      is("android|mobi|mobile|j2me|iphone|ipod|ipad|blackberry|playbook|kindle|silk") ? m : "",

      // os/platform
      is("j2me")
        ? "j2me"
        : is("ipad|ipod|iphone")
        ? (/CPU( iPhone)? OS (\d+[_|\.]\d+([_|\.]\d+)*)/i.test(ua) ? "ios" + version("ios", RegExp.$2) : "") + " " + (/(ip(ad|od|hone))/gi.test(ua) ? RegExp.$1 : "")
        : //'iphone'
        //:is('ipod')?'ipod'
        //:is('ipad')?'ipad'
        is("playbook")
        ? "playbook"
        : is("kindle|silk")
        ? "kindle"
        : is("playbook")
        ? "playbook"
        : is("mac")
        ? "mac" + (/mac os x ((\d+)[.|_](\d+))/.test(ua) ? " mac" + RegExp.$2 + " mac" + RegExp.$1.replace(".", "_") : "")
        : is("win")
        ? "win" +
          (is("windows nt 6.2")
            ? " win8"
            : is("windows nt 6.1")
            ? " win7"
            : is("windows nt 6.0")
            ? " vista"
            : is("windows nt 5.2") || is("windows nt 5.1")
            ? " win_xp"
            : is("windows nt 5.0")
            ? " win_2k"
            : is("windows nt 4.0") || is("WinNT4.0")
            ? " win_nt"
            : "")
        : is("freebsd")
        ? "freebsd"
        : is("x11|linux")
        ? "linux"
        : "",

      // user agent language
      /[; |\[](([a-z]{2})(\-[a-z]{2})?)[)|;|\]]/i.test(ua) ? (lang + RegExp.$2).replace("-", "_") + (RegExp.$3 != "" ? (" " + lang + RegExp.$1).replace("-", "_") : "") : "",

      // beta: test if running iPad app
      is("ipad|iphone|ipod") && !is("safari") ? "ipad_app" : "",
    ]; // b

  console.debug(ua);

  function screenSize() {
    var w = window.outerWidth || html.clientWidth;
    var h = window.outerHeight || html.clientHeight;
    uaInfo.orientation = w < h ? "portrait" : "landscape";
    // remove previous min-width, max-width, client-width, client-height, and orientation
    html.className = html.className.replace(/ ?orientation_\w+/g, "").replace(/ [min|max|cl]+[w|h]_\d+/g, "");
    for (var i = allScreens - 1; i >= 0; i--) {
      if (w >= screens[i]) {
        uaInfo.maxw = screens[i];
        break;
      }
    }
    widthClasses = "";
    for (var info in uaInfo) {
      widthClasses += " " + info + "_" + uaInfo[info];
    }
    html.className = html.className + widthClasses;
    return widthClasses;
  } // screenSize

  window.onresize = screenSize;
  screenSize();

  function retina() {
    var r = window.devicePixelRatio > 1;
    if (r) {
      html.className += " retina";
    } else {
      html.className += " non-retina";
    }
  }
  retina();

  var cssbs = b.join(" ") + " js ";
  html.className = (cssbs + html.className.replace(/\b(no[-|_]?)?js\b/g, "")).replace(/^ /, "").replace(/ +/g, " ");

  return cssbs;
}

css_browser_selector(navigator.userAgent);
//     Underscore.js 1.9.1
//     https://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

var debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
/**
 * Object Fit Videos
 * Polyfill for object-fit and object-position CSS properties on video elements
 * Covers IE9, IE10, IE11, Edge, Safari <10
 *
 * Usage
 * In your CSS, add a special font-family tag for IE/Edge
 * video {
 *   object-fit: cover;
 *   font-family: 'object-fit: cover;';
 * }
 *
 * Before the closing body tag, or whenever the DOM is ready,
 * make the JavaScript call
 * objectFitVideos();
 *
 * All video elements with the special CSS property will be targeted
 *
 * @license  MIT (https://opensource.org/licenses/MIT)
 * @author   Todd Miller <todd.miller@tricomb2b.com>
 * @version  1.0.2
 * @changelog
 * 2016-08-19 - Adds object-position support.
 * 2016-08-19 - Add throttle function for more performant resize events
 * 2016-08-19 - Initial release with object-fit support, and
 *              object-position default 'center'
 * 2016-10-14 - No longer relies on window load event, instead requires a specific
 *              function call to initialize the videos for object fit and position.
 * 2016-11-28 - Support CommonJS environment, courtesy of @msorensson
 * 2016-12-05 - Refactors the throttling function to support IE
 * 2017-09-26 - Fix an issue with autplay not working on polyfilled videos
 *            - Adds the capability to specify elements to polyfill,
 *              instead of just checking every video element for the
 *              CSS property. Slight performance gain in most usecases,
 *              and a bigger gain in a few usecases.
 * 2017-10-24 - Add user agent check to enable polyfill for all Edge browsers.
 *              object-fit is supported on Edge >= 16, but currently just for images.
 */
var objectFitVideos = function (videos) {
  "use strict";

  var isEdge = navigator.userAgent.indexOf("Edge/") >= 0;

  var testImg = new Image(),
    supportsObjectFit = "object-fit" in testImg.style && !isEdge,
    supportsObjectPosition = "object-position" in testImg.style && !isEdge,
    propRegex = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;

  if (!supportsObjectFit || !supportsObjectPosition) {
    initialize(videos);
    throttle("resize", "optimizedResize");
  }

  /**
   * Parse the style and look for the special font-family tag
   * @param  {object} $el The element to parse
   * @return {object}     The font-family properties we're interested in
   */
  function getStyle($el) {
    var style = getComputedStyle($el).fontFamily,
      parsed = null,
      props = {};

    while ((parsed = propRegex.exec(style)) !== null) {
      props[parsed[1]] = parsed[2];
    }

    if (props["object-position"]) return parsePosition(props);

    return props;
  }

  /**
   * Initialize all the relevant video elements and get them fitted
   */
  function initialize(videos) {
    var index = -1;

    if (!videos) {
      // if no videos given, query all video elements
      videos = document.querySelectorAll("video");
    } else if (!("length" in videos)) {
      // convert to an array for proper looping if an array or NodeList
      // was not given
      videos = [videos];
    }

    while (videos[++index]) {
      var style = getStyle(videos[index]);

      // only do work if the property is on the element
      if (style["object-fit"] || style["object-position"]) {
        // set the default values
        style["object-fit"] = style["object-fit"] || "fill";
        fitIt(videos[index], style);
      }
    }
  }

  /**
   * Object Fit
   * @param  {object} $el Element to fit
   * @return {object}     The element's relevant properties
   */
  function fitIt($el, style) {
    // fill is the default behavior, no action is necessary
    if (style["object-fit"] === "fill") return;

    // convenience style properties on the source element
    var setCss = $el.style,
      getCss = window.getComputedStyle($el);

    // create and insert a wrapper element
    var $wrap = document.createElement("object-fit");
    $wrap.appendChild($el.parentNode.replaceChild($wrap, $el));

    // style the wrapper element to mostly match the source element
    var wrapCss = {
      height: "100%",
      width: "100%",
      boxSizing: "content-box",
      display: "inline-block",
      overflow: "hidden",
    };

    "backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight left opacity margin position right top visibility".replace(/\w+/g, function (
      key
    ) {
      wrapCss[key] = getCss[key];
    });

    for (var key in wrapCss) $wrap.style[key] = wrapCss[key];

    // give the source element some saner styles
    setCss.border = setCss.margin = setCss.padding = 0;
    setCss.display = "block";
    setCss.opacity = 1;

    // set up the event handlers
    $el.addEventListener("loadedmetadata", doWork);
    window.addEventListener("optimizedResize", doWork);

    // we may have missed the loadedmetadata event, so if the video has loaded
    // enough data, just drop the event listener and execute
    if ($el.readyState >= 1) {
      $el.removeEventListener("loadedmetadata", doWork);
      doWork();
    }

    /**
     * Do the actual sizing. Math.
     * @methodOf fitIt
     */
    function doWork() {
      // the actual size and ratio of the video
      // we do this here, even though it doesn't change, because
      // at this point we can be sure the metadata has loaded
      var videoWidth = $el.videoWidth,
        videoHeight = $el.videoHeight,
        videoRatio = videoWidth / videoHeight;

      var wrapWidth = $wrap.clientWidth,
        wrapHeight = $wrap.clientHeight,
        wrapRatio = wrapWidth / wrapHeight;

      var newHeight = 0,
        newWidth = 0;
      setCss.marginLeft = setCss.marginTop = 0;

      // basically we do the opposite action for contain and cover,
      // depending on whether the video aspect ratio is less than or
      // greater than the wrapper's aspect ratio
      if (videoRatio < wrapRatio ? style["object-fit"] === "contain" : style["object-fit"] === "cover") {
        newHeight = wrapHeight * videoRatio;
        newWidth = wrapWidth / videoRatio;

        setCss.width = Math.round(newHeight) + "px";
        setCss.height = wrapHeight + "px";

        if (style["object-position-x"] === "left") setCss.marginLeft = 0;
        else if (style["object-position-x"] === "right") setCss.marginLeft = Math.round(wrapWidth - newHeight) + "px";
        else setCss.marginLeft = Math.round((wrapWidth - newHeight) / 2) + "px";
      } else {
        newWidth = wrapWidth / videoRatio;

        setCss.width = wrapWidth + "px";
        setCss.height = Math.round(newWidth) + "px";

        if (style["object-position-y"] === "top") setCss.marginTop = 0;
        else if (style["object-position-y"] === "bottom") setCss.marginTop = Math.round(wrapHeight - newWidth) + "px";
        else setCss.marginTop = Math.round((wrapHeight - newWidth) / 2) + "px";
      }

      // play the video if autoplay is set
      if ($el.autoplay) $el.play();
    }
  }

  /**
   * Split the object-position property into x and y position properties
   * @param  {object} style Relevant element styles
   * @return {object}       The style object with the added x and y props
   */
  function parsePosition(style) {
    if (~style["object-position"].indexOf("left")) style["object-position-x"] = "left";
    else if (~style["object-position"].indexOf("right")) style["object-position-x"] = "right";
    else style["object-position-x"] = "center";

    if (~style["object-position"].indexOf("top")) style["object-position-y"] = "top";
    else if (~style["object-position"].indexOf("bottom")) style["object-position-y"] = "bottom";
    else style["object-position-y"] = "center";

    return style;
  }

  /**
   * Throttle an event with RequestAnimationFrame API for better performance
   * @param  {string} type The event to throttle
   * @param  {string} name Custom event name to listen for
   * @param  {object} obj  Optional object to attach the event to
   */
  function throttle(type, name, obj) {
    obj = obj || window;
    var running = false,
      evt = null;

    // IE does not support the CustomEvent constructor
    // so if that fails do it the old way
    try {
      evt = new CustomEvent(name);
    } catch (e) {
      evt = document.createEvent("Event");
      evt.initEvent(name, true, true);
    }

    var func = function () {
      if (running) return;

      running = true;
      requestAnimationFrame(function () {
        obj.dispatchEvent(evt);
        running = false;
      });
    };

    obj.addEventListener(type, func);
  }
};

if (typeof module !== "undefined" && typeof module.exports !== "undefined") module.exports = objectFitVideos;
/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = (function () {
  "use strict";

  var OFI = "fregante:object-fit-images";
  var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
  var testImg = typeof Image === "undefined" ? { style: { "object-position": 1 } } : new Image();
  var supportsObjectFit = "object-fit" in testImg.style;
  var supportsObjectPosition = "object-position" in testImg.style;
  var supportsOFI = "background-size" in testImg.style;
  var supportsCurrentSrc = typeof testImg.currentSrc === "string";
  var nativeGetAttribute = testImg.getAttribute;
  var nativeSetAttribute = testImg.setAttribute;
  var autoModeEnabled = false;

  function createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
  }

  function polyfillCurrentSrc(el) {
    if (el.srcset && !supportsCurrentSrc && window.picturefill) {
      var pf = window.picturefill._;
      // parse srcset with picturefill where currentSrc isn't available
      if (!el[pf.ns] || !el[pf.ns].evaled) {
        // force synchronous srcset parsing
        pf.fillImg(el, { reselect: true });
      }

      if (!el[pf.ns].curSrc) {
        // force picturefill to parse srcset
        el[pf.ns].supported = false;
        pf.fillImg(el, { reselect: true });
      }

      // retrieve parsed currentSrc, if any
      el.currentSrc = el[pf.ns].curSrc || el.src;
    }
  }

  function getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while ((parsed = propRegex.exec(style)) !== null) {
      props[parsed[1]] = parsed[2];
    }
    return props;
  }

  function setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = createPlaceholder(width || 1, height || 0);

    // Only set placeholder if it's different
    if (nativeGetAttribute.call(img, "src") !== placeholder) {
      nativeSetAttribute.call(img, "src", placeholder);
    }
  }

  function onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) {
      callback(img);
    } else {
      setTimeout(onImageReady, 100, img, callback);
    }
  }

  function fixOne(el) {
    var style = getStyle(el);
    var ofi = el[OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value

    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
      // fill is the default behavior so no action is necessary
      if (style["object-fit"] === "fill") {
        return;
      }

      // Where object-fit is supported and object-position isn't (Safari < 10)
      if (
        !ofi.skipTest && // unless user wants to apply regardless of browser support
        supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
      ) {
        return;
      }
    }

    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
      ofi.img = new Image(el.width, el.height);
      ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
      ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

      // preserve for any future cloneNode calls
      // https://github.com/fregante/object-fit-images/issues/53
      nativeSetAttribute.call(el, "data-ofi-src", el.src);
      if (el.srcset) {
        nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
      }

      setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

      // remove srcset because it overrides src
      if (el.srcset) {
        el.srcset = "";
      }
      try {
        keepSrcUsable(el);
      } catch (err) {
        if (window.console) {
          console.warn("https://bit.ly/ofi-old-browser");
        }
      }
    }

    polyfillCurrentSrc(ofi.img);

    el.style.backgroundImage = 'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";

    if (/scale-down/.test(style["object-fit"])) {
      onImageReady(ofi.img, function () {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
          el.style.backgroundSize = "contain";
        } else {
          el.style.backgroundSize = "auto";
        }
      });
    } else {
      el.style.backgroundSize = style["object-fit"].replace("none", "auto").replace("fill", "100% 100%");
    }

    onImageReady(ofi.img, function (img) {
      setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
  }

  function keepSrcUsable(el) {
    var descriptors = {
      get: function get(prop) {
        return el[OFI].img[prop ? prop : "src"];
      },
      set: function set(value, prop) {
        el[OFI].img[prop ? prop : "src"] = value;
        nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
        fixOne(el);
        return value;
      },
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
      get: function () {
        return descriptors.get("currentSrc");
      },
    });
    Object.defineProperty(el, "srcset", {
      get: function () {
        return descriptors.get("srcset");
      },
      set: function (ss) {
        return descriptors.set(ss, "srcset");
      },
    });
  }

  function hijackAttributes() {
    function getOfiImageMaybe(el, name) {
      return el[OFI] && el[OFI].img && (name === "src" || name === "srcset") ? el[OFI].img : el;
    }
    if (!supportsObjectPosition) {
      HTMLImageElement.prototype.getAttribute = function (name) {
        return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
      };

      HTMLImageElement.prototype.setAttribute = function (name, value) {
        return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
      };
    }
  }

  function fix(imgs, opts) {
    var startAutoMode = !autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";

    if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
      return false;
    }

    // use imgs as a selector or just select all images
    if (imgs === "img") {
      imgs = document.getElementsByTagName("img");
    } else if (typeof imgs === "string") {
      imgs = document.querySelectorAll(imgs);
    } else if (!("length" in imgs)) {
      imgs = [imgs];
    }

    // apply fix to all
    for (var i = 0; i < imgs.length; i++) {
      imgs[i][OFI] = imgs[i][OFI] || {
        skipTest: opts.skipTest,
      };
      fixOne(imgs[i]);
    }

    if (startAutoMode) {
      document.body.addEventListener(
        "load",
        function (e) {
          if (e.target.tagName === "IMG") {
            fix(e.target, {
              skipTest: opts.skipTest,
            });
          }
        },
        true
      );
      autoModeEnabled = true;
      imgs = "img"; // reset to a generic selector for watchMQ
    }

    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) {
      window.addEventListener(
        "resize",
        fix.bind(null, imgs, {
          skipTest: opts.skipTest,
        })
      );
    }
  }

  fix.supportsObjectFit = supportsObjectFit;
  fix.supportsObjectPosition = supportsObjectPosition;

  hijackAttributes();

  return fix;
})();
/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
"document" in self &&
  (("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) ||
    !(function (t) {
      "use strict";
      if ("Element" in t) {
        var e = "classList",
          n = "prototype",
          i = t.Element[n],
          s = Object,
          r =
            String[n].trim ||
            function () {
              return this.replace(/^\s+|\s+$/g, "");
            },
          o =
            Array[n].indexOf ||
            function (t) {
              for (var e = 0, n = this.length; n > e; e++) if (e in this && this[e] === t) return e;
              return -1;
            },
          c = function (t, e) {
            (this.name = t), (this.code = DOMException[t]), (this.message = e);
          },
          a = function (t, e) {
            if ("" === e) throw new c("SYNTAX_ERR", "The token must not be empty.");
            if (/\s/.test(e)) throw new c("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
            return o.call(t, e);
          },
          l = function (t) {
            for (var e = r.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], i = 0, s = n.length; s > i; i++) this.push(n[i]);
            this._updateClassName = function () {
              t.setAttribute("class", this.toString());
            };
          },
          u = (l[n] = []),
          h = function () {
            return new l(this);
          };
        if (
          ((c[n] = Error[n]),
          (u.item = function (t) {
            return this[t] || null;
          }),
          (u.contains = function (t) {
            return ~a(this, t + "");
          }),
          (u.add = function () {
            var t,
              e = arguments,
              n = 0,
              i = e.length,
              s = !1;
            do (t = e[n] + ""), ~a(this, t) || (this.push(t), (s = !0));
            while (++n < i);
            s && this._updateClassName();
          }),
          (u.remove = function () {
            var t,
              e,
              n = arguments,
              i = 0,
              s = n.length,
              r = !1;
            do for (t = n[i] + "", e = a(this, t); ~e; ) this.splice(e, 1), (r = !0), (e = a(this, t));
            while (++i < s);
            r && this._updateClassName();
          }),
          (u.toggle = function (t, e) {
            var n = this.contains(t),
              i = n ? e !== !0 && "remove" : e !== !1 && "add";
            return i && this[i](t), e === !0 || e === !1 ? e : !n;
          }),
          (u.replace = function (t, e) {
            var n = a(t + "");
            ~n && (this.splice(n, 1, e), this._updateClassName());
          }),
          (u.toString = function () {
            return this.join(" ");
          }),
          s.defineProperty)
        ) {
          var f = { get: h, enumerable: !0, configurable: !0 };
          try {
            s.defineProperty(i, e, f);
          } catch (p) {
            (void 0 !== p.number && -2146823252 !== p.number) || ((f.enumerable = !1), s.defineProperty(i, e, f));
          }
        } else s[n].__defineGetter__ && i.__defineGetter__(e, h);
      }
    })(self),
  (function () {
    "use strict";
    var t = document.createElement("_");
    if ((t.classList.add("c1", "c2"), !t.classList.contains("c2"))) {
      var e = function (t) {
        var e = DOMTokenList.prototype[t];
        DOMTokenList.prototype[t] = function (t) {
          var n,
            i = arguments.length;
          for (n = 0; i > n; n++) (t = arguments[n]), e.call(this, t);
        };
      };
      e("add"), e("remove");
    }
    if ((t.classList.toggle("c3", !1), t.classList.contains("c3"))) {
      var n = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (t, e) {
        return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
      };
    }
    "replace" in document.createElement("_").classList ||
      (DOMTokenList.prototype.replace = function (t, e) {
        var n = this.toString().split(" "),
          i = n.indexOf(t + "");
        ~i && ((n = n.slice(i)), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
      }),
      (t = null);
  })());
